/**
 * Markdown 导出服务
 * 将 Markdown 内容导出为原始 Markdown 文件
 */

import { ExportOptions } from '../../../types/export'
import { downloadBlob } from '../../../utils/download'
import { generateExportFilename } from './exportStyles'

/**
 * 导出为 Markdown 文件
 */
export const exportToMarkdown = async (
  content: string,
  options: ExportOptions
): Promise<void> => {
  try {
    // 创建 Markdown 内容
    let markdownContent = content
    
    // 添加标题（如果提供了标题）
    if (options.title) {
      markdownContent = `# ${options.title}\n\n${markdownContent}`
    }
    
    // 创建 blob
    const blob = new Blob([markdownContent], { type: 'text/markdown;charset=utf-8' })
    
    // 下载文件
    const filename = generateExportFilename('md', options.filename)
    downloadBlob(blob, filename)
    
  } catch (error) {
    console.error('Markdown 导出失败:', error)
    throw new Error(`Markdown 导出失败: ${error instanceof Error ? error.message : '未知错误'}`)
  }
}

/**
 * 预览 Markdown 内容
 */
export const previewMarkdown = (
  content: string,
  options: ExportOptions
): string => {
  let markdownContent = content
  
  if (options.title) {
    markdownContent = `# ${options.title}\n\n${markdownContent}`
  }
  
  return markdownContent
}

/**
 * 检查浏览器是否支持 Markdown 导出
 */
export const checkMarkdownSupport = (): boolean => {
  // Markdown 导出只需要 Blob API 支持
  return typeof Blob !== 'undefined' && typeof URL !== 'undefined'
}